/* eslint-disable import/no-cycle */
import { GET_ALL_UNSEEN_BADGES, SET_BADGES_SEEN } from "lib/constants";
import { getAPICall, postAPICall } from "../lib/callApi";

export const getAllUnseenBadges = async (payload) => {
  const data = await getAPICall(GET_ALL_UNSEEN_BADGES, true, payload);
  return data;
};

export const setBadgesAsSeen = async (payload) => {
  const data = await postAPICall(SET_BADGES_SEEN, true, payload);
  return data;
};
